import get from 'lodash/get';
import compose from 'lodash/fp/compose';

const transactionTypeTwia = model => get(model, 'baseData.jobType', 'Unknown');
const isRenewalTwia = s => s === 'Renewal';
const isSubmissionTwia = s => s === 'Submission';
const isPolicyChangeTwia = s => s === 'PolicyChange';

const isRenewal = (model) => compose(isRenewalTwia, transactionTypeTwia)(model);
    const isSubmission = (model) => compose(isSubmissionTwia, transactionTypeTwia)(model);
    const isPolicyChange = (model) => compose(isPolicyChangeTwia, transactionTypeTwia)(model);
    const isEitherRenewalOrPolicyChange = (model) => isPolicyChange(model) || isRenewal(model);

export default {
    'isRenewal': isRenewal,
    'isSubmission': isSubmission,
    'isPolicyChange': isPolicyChange,
    // eslint-disable-next-line no-secrets/no-secrets
    'isEitherRenewalOrPolicyChange': isEitherRenewalOrPolicyChange
}
